import Vue from 'vue'
import Router from 'vue-router'
import routers from './routers'
import api from '@/api'
import { whatAppName, APP_NAME_ENUM } from "@/utils";
import { shouldForceBindPhone, shouldForceBindWx } from "@/utils/auth-strategy";

const fetch = api.fetch
const bindWxUrl = '/sellerRegister'
const bindPhoneUrl = '/sellerRegister?type=bind_phone'

Vue.use(Router)

const router = new Router({
    linkActiveClass: 'active',
    routes: routers
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.auth) {
    // 授权
    fetch.get({
      url: '/user'
    }).then((data) => {
      if (data.success && data.user) {
        if (shouldForceBindPhone(data.user) && !to.fullPath.startsWith(bindPhoneUrl)) {
          Vue.prototype.$message.error('请先绑定手机号')
          next(bindPhoneUrl)
        } else if (
          shouldForceBindWx(data.user) && whatAppName() !== APP_NAME_ENUM.boss && !to.fullPath.startsWith(bindWxUrl)
        ) {
          Vue.prototype.$message.error('请先绑定微信')
          next(bindWxUrl)
        } else {
          next();
        }
      }else {
        Vue.prototype.$message.error('请先登录');
        next('/login');
        document.title = '登录';
      }
    }, e => {
      if (e.error_text.includes('用户未登录')) {
        Vue.prototype.$message.error('请先登录');
        next('/login');
      }else {
        next('/login');
      }
      document.title = '登录';
    });
  }else {
    next();
  }
})

export default router
